import intl from "react-intl-universal";

import {SectionMessage} from "../../components/SectionMessage";
import {Button} from "../../components/Button";

import {clearAllDataAndRefresh} from "../../../utils/clearAllDataAndRefresh";


import './HardRefreshWarning.css';


export interface HardRefreshWarningProps {
    className?: string;
}


export const HardRefreshWarning = ({className}: HardRefreshWarningProps) => {
    const contact_us = `<button onclick="window.open('/pricing#Contact_us', '_blank').focus();"
 class="btn btn--inline btn--primary btn--clickable title-medium">${intl.get('hard_refresh.contact_us').d('Contact us')}</button>`;

    return (
        <SectionMessage
            className={className}
            variant={'warning'}
            title={intl.get('hard_refresh.warning_title').d('Having Trouble Loading?')}
            maxWidth={'640px'}
            message={(
                <>
                    <div>{intl.get('hard_refresh.warning').d(`If the page fails to load, click "Restart" to clear the cache and reload the page. You may also try closing and reopening your browser.`)}</div>
                    <div>
                        {intl.getHTML('hard_refresh.contact_us_row', {contact_us}).d(`Still having trouble? {contact_us} for help`)}
                    </div>
                    <div className="HardRefreshWarning__btns">
                        <Button
                            type={'primary'}
                            size={'md'}
                            style={'solid'}
                            text={intl.get('hard_refresh.button').d('Restart')}
                            onClick={clearAllDataAndRefresh}
                        />
                    </div>
                </>
            )}
        />
    )
}
